import * as React from 'react';
import '../../styles/Footer.css';

function PublicFooter() {
    let currentYear = new Date().getFullYear();

    return (
        <footer className="public-footer">
            <div className="container h-100 d-flex justify-content-center align-items-end">
                <span className="pb-2">&copy; {currentYear} Tour24. All Rights Reserved.</span>
            </div>
        </footer>
    );
}

export default PublicFooter;



// WEBPACK FOOTER //
// ./src/components/common/PublicFooter.tsx